import { defineComponent as r, createBlock as a, openBlock as m, unref as p, mergeProps as l, withCtx as c, createElementVNode as o } from "vue";
import { RevIcon as f } from "@ds/components/Icon";
const d = /* @__PURE__ */ r({
  name: "IconPerformance",
  __name: "IconPerformance",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const n = t;
    return (s, e) => (m(), a(p(f), l(n, { "view-box": "0 0 24 24" }), {
      default: c(() => [...e[0] || (e[0] = [
        o("path", { d: "M4.75 13.5a7.25 7.25 0 0 1 10.422-6.522.75.75 0 1 0 .656-1.348 8.75 8.75 0 0 0-10.66 13.34.75.75 0 1 0 1.172-.94 7.216 7.216 0 0 1-1.59-4.53m15.12-3.829a.75.75 0 0 0-1.348.658A7.218 7.218 0 0 1 19.25 13.5a7.216 7.216 0 0 1-1.59 4.53.75.75 0 1 0 1.17.94 8.717 8.717 0 0 0 1.92-5.47 8.719 8.719 0 0 0-.88-3.829" }, null, -1),
        o("path", { d: "M19.53 5.97a.75.75 0 0 1 0 1.06l-6.08 6.081a1.5 1.5 0 1 1-1.06-1.06l6.08-6.081a.75.75 0 0 1 1.06 0" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  d as default
};
